import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
  getTalentMessages,
  setChatSelected,
  setIsChatting,
  setJobSelected,
  setStaffSelected,
  setChatList,
  setOpenChatListModal, setIsNewChatFormOtherScreen
} from "reducers/chatMessage";
import {ThunkDispatch} from "@reduxjs/toolkit";
import staffAvatar from '../../../../assets/img/noAvatarAdmin.svg';
import staffAvatarText from '../../../../assets/img/noAvatarAdminText.svg';
import {formatChatConversationTime} from "utils/format";
import parse from "html-react-parser";
import { clearHTMLTag } from "../../../utils/format";
import {LoadingIcon} from "components/Icons";
import { MOBILE_SCREEN_WIDTH } from "../../../constants/index";

const ChatList = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const { chatList, chatSelected, loadingGetListChat } = useSelector((state: any) => state.chatMessage);
  let {talentInfo} = useSelector((state: any) => state.currentUser)
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth <= MOBILE_SCREEN_WIDTH);

  const handleSelectConvention = (e: any, item: any) => {
    e.preventDefault();
    dispatch(setIsChatting(true));
    dispatch(setIsNewChatFormOtherScreen(false));
    dispatch(setChatSelected(item));
    if(item.main_staff && item.main_staff.id) {
      dispatch(setStaffSelected(item.main_staff));
    }

    // dispatch(getDetailTalent({ id: item?.talent?.id }));
    if(item?.job && item?.job.id) {
      dispatch(setJobSelected(item?.job));
    } else {
      dispatch(setJobSelected({}));
    }
    dispatch(getTalentMessages({ id: item?.id }));

    let newChatList = JSON.parse(JSON.stringify(chatList));
    for(let itemChat of newChatList) {
      if(itemChat.id == item?.id) {
        if(itemChat?.user_read && !itemChat?.user_read.includes(talentInfo.user_id)) {
          itemChat?.user_read?.push(talentInfo.user_id)
        }
        break
      }
    }
    dispatch(setChatList(newChatList));
    dispatch(setOpenChatListModal(false));
  };

  return (
    <div className="flex flex-col">
      {chatList.length > 0 &&
        chatList.map((item: any, idx: any) => (
          <div key={idx}>
            <div
              className={`${
                chatSelected?.id && chatSelected?.id == item.id && !isMobileScreen ? "border-[#FF861A]" : "border-transparent"
              } border rounded-md hover:cursor-pointer hover:bg-[#FFF3E5] px-[0.5rem] py-2 bg-white flex items-center gap-[0.25rem] mt-2 mb-2`}
            >
              <div className="shrink-0 w-10 h-10 relative">
                <img
                  className="shrink-0 w-10 h-10 rounded-full object-cover"
                  src={item.conversation_avatar ? item.conversation_avatar : staffAvatar}
                />
                {item?.conversation_avatar && item?.conversation_avatar.split('/').includes('default_staff_avatar.svg') && <img src={staffAvatarText} alt="" className="absolute left-0 bottom-0 w-5 h-[0.625rem]" />}
              </div>
              <div className="flex-1" onClick={(e: any) => handleSelectConvention(e, item)}>
                <div className="flex items-baseline justify-between mb-1 gap-2">
                  <p
                    className={`flex items-baseline gap-1 text-base alu-text-base-2 ${item?.user_read?.includes(talentInfo.user_id) ? "font-normal" : "font-bold"
                    }`}>
                    <span>{item.conversation_name}</span>
                    {item?.type?.label && <span className="shrink-0 rounded-2xl min-w-[3rem] px-[0.25rem] py-[0.125rem] text-center bg-[#CCE4FF] font-normal text-[0.75rem] leading-4">
                        {item?.type?.label}
                    </span>}
                  </p>
                  <p className="min-w-[2.75rem] shrink-0 text-sm font-normal alu-text-base-1 text-right">
                    {formatChatConversationTime(item?.last_message?.send_at)}
                  </p>
                </div>
                <p className="text-sm font-normal alu-text-base-1 max-w-[17rem] sm:max-w-[13.75rem] xl:max-w-[17rem] truncate">
                  {talentInfo.user_id == item.last_message?.user_id ? '自分: ' + parse(clearHTMLTag(item.last_message?.content)) : parse(clearHTMLTag(item.last_message?.content))}
                </p>
              </div>
            </div>
            {idx !== chatList.length - 1 && (
              <div className="h-[1px] w-full bg-[#E0E0E0]"></div>
            )}
          </div>
        ))}
      {loadingGetListChat && (
        <div className="flex items-center justify-center"><LoadingIcon/></div>
      )}
    </div>
  );
};

export default ChatList;
